// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7857":"809b87b8","8869":"809b87b8","9973":"809b87b8"}[chunkId] + ".chunk.css";
};